module.exports = __webpack_public_path__ + "img/33_24.bd0e33ef.png";